
export const DefaultColors = {
  blue: '#4990E2',
  green: '#9FC522',
  red: '#D0021B',
  yellow: '#FFE200'
};


